import { api } from './client';
export async function fetchAdminMe() {
    const res = await api.get('/v1/admin/me');
    return res.data;
}
